import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';

@Component({
    selector: 'child-cell',
    template: `<a rel="nofollow noreferrer noopener" href="javascript:void(0)" (click)="download()">Download</a>`,
    styles: [
        `i:hover {
      cursor: pointer;
    }`,
    ],
    standalone: false
})

export class DownloadAnchorTagComponent implements ICellRendererAngularComp {
  params: any;
  isPresented = false;

  agInit(params: any): void {
    this.params = params;
  }

  download() {
    this.params.onClick(this.params.data);
  }

  refresh(): boolean {
    return false;
  }
}
